export default "__VITE_ASSET__CNTD$5va__"